// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"QuotePageFooter_disclaimer__21fUB"};